import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSize, useReactive } from "ahooks";
import general from "../../../general";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import $ from "jquery";
import dayjs from "dayjs";
import { sysUrl, activityUrl } from "../../../config";
import { NavLink } from "../../../lib/Navigation";
import "swiper/swiper-bundle.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { splitStr } from "../../../utils/commonFunc";

// 初始化Swiper模块
SwiperCore.use([Autoplay, Pagination]);

export default (props) => {
  let [game, setGame] = useState({});
  const openService = useReactive({
    info: {
      dayTime: "",
      serviceName: "",
    },
  });
  const [init, setInit] = useState();

  useEffect(() => {
    game = props.game;
    setGame(props.game);

    let list = props.game.kaifu_info;
    if (list && list.length > 0) {
      console.log(list);
      // 获取当前时间 若第一项为今日日期  则显示今天 00:00(截取时间)
      let nowDay = dayjs().format("MM.DD");

      let firstTime = game.game_control_info?.server_info?.starttime ? dayjs.unix(game.game_control_info.server_info.starttime).format("MM.DD HH:mm") : '';
      console.log(nowDay, firstTime);

      if (firstTime) {
        if (nowDay === firstTime.split(" ")[0]) {
          openService.info.dayTime = "今天 " + firstTime.split(" ")[1];
        } else {
          openService.info.dayTime = firstTime;
        }
      } else {
        openService.info.dayTime = '';
      }

      openService.info.serviceName =
        game.game_control_info?.server_info?.kaifuname || '动态开服中';
    }

    setInit(true);
  }, [props.game]);

  const [manufacturerInfoMore, setManufacturerInfoMore] = useState(false);
  const [manufacturerMored, setManufacturerMored] = useState(false);
  const manufacturerBodyRef = useRef();
  const manufacturerEntityRef = useRef();
  const manufacturerBodySize = useSize(manufacturerBodyRef);
  const manufacturerEntitySize = useSize(manufacturerEntityRef);
  const manufacturerInfoInitialized = useRef(false);
  useEffect(() => {
    // 只在第一次测量时进行比较和设置，之后不再更新，避免循环
    if (
      !manufacturerMored &&
      !manufacturerInfoInitialized.current &&
      manufacturerEntitySize?.height &&
      manufacturerBodySize?.height
    ) {
      console.log(
        "aaaaaaaaaaa----",
        manufacturerEntitySize?.height,
        manufacturerBodySize?.height
      );

      const shouldShowMore =
        manufacturerEntitySize.height > manufacturerBodySize.height;
      console.log("shouldShowMore----", shouldShowMore);

      setManufacturerInfoMore(shouldShowMore);
      manufacturerInfoInitialized.current = true;
    }
  }, [manufacturerBodySize, manufacturerEntitySize, manufacturerMored]);

  const imgRef = useCallback((node) => {
    if (node) {
      // 同时设置 gameImgsRef
      gameImgsRef.current = node;

      let container = $(node).find(".container")[0];
      var startScroll, touchStart, touchCurrent;
      node.addEventListener(
        "touchstart",
        (e) => {
          startScroll = container.scrollLeft;
          touchStart = e.targetTouches[0].pageX;
        },
        { passive: false }
      );
      node.addEventListener(
        "touchmove",
        (e) => {
          touchCurrent = e.targetTouches[0].pageX;
          var touchesDiff = touchCurrent - touchStart;
          var onlyScrolling =
            container.scrollWidth > container.offsetWidth &&
            ((touchesDiff < 0 && startScroll === 0) ||
              (touchesDiff > 0 &&
                startScroll ===
                container.scrollWidth - container.offsetWidth) ||
              (startScroll > 0 &&
                startScroll < container.scrollWidth - container.offsetWidth));
          if (onlyScrolling) {
            e.stopPropagation();
          }
        },
        { passive: false }
      );
    } else {
      gameImgsRef.current = null;
    }
  }, []);

  const recommend = () => {
    Dialog.loading();
    general.axios
      .post("/v3/base/newindex/GameLike", { game_id: game.game_id })
      .finally(() => {
        Dialog.close();
      })
      .then((response) => {
        let { status, data } = response.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        props.setGame((game) => ({ ...game, recommend_info: data.list }));
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const videoRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState(null);
  const [imageHeight, setImageHeight] = useState(null);
  const gameImgsRef = useRef(null);

  // 获取 video 高度并设置到 bannerImg
  useEffect(() => {
    const getVideoHeight = () => {
      if (videoRef.current) {
        const video = videoRef.current;
        // 优先使用视频的实际宽高比来计算高度
        if (video.videoWidth && video.videoHeight) {
          const screenWidth = window.innerWidth;
          const aspectRatio = video.videoHeight / video.videoWidth;
          const calculatedHeight = screenWidth * aspectRatio;
          const maxHeight = window.innerHeight * 0.55; // 55vh
          const finalHeight = Math.min(calculatedHeight, maxHeight);

          if (finalHeight > 0) {
            setVideoHeight(Math.ceil(finalHeight));
            // 更新swiper，确保pagination位置正确
            if (swiperGameImgRef.current?.swiper) {
              try {
                swiperGameImgRef.current.swiper.update();
              } catch (e) {
                // swiper可能已被销毁，忽略错误
              }
            }
            return;
          }
        }

        // 如果视频宽高比不可用，使用offsetHeight或videoHeight
        const height = video.offsetHeight || video.videoHeight;
        if (height) {
          const ceilHeight = Math.ceil(height);
          setVideoHeight(ceilHeight);
        }
      }
    };

    const handleVideoLoadedMetadata = () => {
      getVideoHeight();
    };

    if (videoRef.current) {
      videoRef.current.addEventListener(
        "loadedmetadata",
        handleVideoLoadedMetadata
      );
      videoRef.current.addEventListener(
        "loadeddata",
        handleVideoLoadedMetadata
      );
      // 如果已经加载完成，直接获取高度
      if (videoRef.current.readyState >= 1) {
        handleVideoLoadedMetadata();
      }
    }

    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener(
          "loadedmetadata",
          handleVideoLoadedMetadata
        );
        videoRef.current.removeEventListener(
          "loadeddata",
          handleVideoLoadedMetadata
        );
      }
    };
  }, [game.video_url]);

  // 监听 poster 图片加载，并等待视频元数据加载
  useEffect(() => {
    if (!game?.video_img_url || !videoRef.current || !game.video_url) {
      return;
    }

    // 如果还没有设置高度，先设置一个默认高度，避免初始时容器高度太小导致pagination定位在屏幕中间
    if (!videoHeight) {
      const defaultHeight = Math.ceil(window.innerWidth * 0.5625); // 16:9 比例
      const maxHeight = window.innerHeight * 0.55; // 55vh
      const finalHeight = Math.min(defaultHeight, maxHeight);
      setVideoHeight(Math.ceil(finalHeight));
    }

    const video = videoRef.current;
    let resizeObserver = null;
    let posterLoaded = false;
    let videoMetadataLoaded = false;

    const calculateAndSetHeight = (useVideoRatio = false) => {
      if (useVideoRatio && video && video.videoWidth && video.videoHeight) {
        // 使用视频的实际宽高比
        const screenWidth = window.innerWidth;
        const aspectRatio = video.videoHeight / video.videoWidth;
        const calculatedHeight = screenWidth * aspectRatio;
        const maxHeight = window.innerHeight * 0.55; // 55vh
        const finalHeight = Math.min(calculatedHeight, maxHeight);

        if (finalHeight > 0) {
          setVideoHeight(Math.ceil(finalHeight));
          // 更新swiper，确保pagination位置正确
          if (swiperGameImgRef.current?.swiper) {
            try {
              swiperGameImgRef.current.swiper.update();
            } catch (e) {
              // swiper可能已被销毁，忽略错误
            }
          }
          return true;
        }
      }
      return false;
    };

    // 创建图片对象来预加载poster
    const img = new window.Image();

    const handlePosterLoad = () => {
      posterLoaded = true;

      // 如果视频元数据已经加载，直接使用视频的宽高比
      if (video && video.videoWidth && video.videoHeight) {
        videoMetadataLoaded = true;
        calculateAndSetHeight(true);
        return;
      }

      // 视频元数据未加载，立即使用poster的宽高比设置高度，避免布局跳跃
      // 这样可以确保pagination从一开始就定位在正确的位置
      if (img.naturalWidth && img.naturalHeight) {
        const screenWidth = window.innerWidth;
        const aspectRatio = img.naturalHeight / img.naturalWidth;
        const calculatedHeight = screenWidth * aspectRatio;
        const maxHeight = window.innerHeight * 0.55; // 55vh
        const finalHeight = Math.min(calculatedHeight, maxHeight);

        if (finalHeight > 0) {
          setVideoHeight(Math.ceil(finalHeight));
          // 立即更新swiper，确保pagination位置正确
          if (swiperGameImgRef.current?.swiper) {
            setTimeout(() => {
              if (swiperGameImgRef.current?.swiper) {
                try {
                  swiperGameImgRef.current.swiper.update();
                } catch (e) {
                  // swiper可能已被销毁，忽略错误
                }
              }
            }, 0);
          }
        }
      }

      // 监听视频元数据加载，如果宽高比不同，再更新高度
      const handleVideoMetadata = () => {
        if (video && video.videoWidth && video.videoHeight) {
          videoMetadataLoaded = true;

          // 检查视频的实际宽高比是否与poster不同
          const videoAspectRatio = video.videoHeight / video.videoWidth;
          const posterAspectRatio = img.naturalHeight / img.naturalWidth;
          const aspectRatioDiff = Math.abs(
            videoAspectRatio - posterAspectRatio
          );

          // 如果宽高比差异较大（超过1%），更新为视频的实际宽高比
          if (aspectRatioDiff > 0.01) {
            calculateAndSetHeight(true);
          }
        }
        if (video) {
          video.removeEventListener("loadedmetadata", handleVideoMetadata);
        }
      };

      if (video) {
        video.addEventListener("loadedmetadata", handleVideoMetadata);
        // 如果已经加载完成，直接处理
        if (video.readyState >= 1 && video.videoWidth && video.videoHeight) {
          handleVideoMetadata();
        }
      }

      // 使用ResizeObserver监听video尺寸变化，作为备用方案
      if (video && window.ResizeObserver) {
        resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            const height =
              entry.contentRect.height || entry.target.offsetHeight;
            if (height && height > 0) {
              const ceilHeight = Math.ceil(height);
              setVideoHeight(ceilHeight);
              // 更新swiper，确保pagination位置正确
              if (swiperGameImgRef.current?.swiper) {
                try {
                  swiperGameImgRef.current.swiper.update();
                } catch (e) {
                  // swiper可能已被销毁，忽略错误
                }
              }
            }
          }
        });
        resizeObserver.observe(video);
      }
    };

    img.onload = handlePosterLoad;
    img.onerror = () => {
      // 即使poster加载失败，也继续等待视频元数据
      posterLoaded = true;
    };
    img.src = game.video_img_url;

    // 如果poster已经加载完成（缓存情况）
    if (img.complete) {
      handlePosterLoad();
    }

    return () => {
      img.onload = null;
      img.onerror = null;
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [game?.video_img_url, game.video_url]);

  // 监听窗口大小变化，重新获取 video 高度
  useEffect(() => {
    const handleResize = () => {
      if (videoRef.current && game.video_url) {
        const height =
          videoRef.current.offsetHeight || videoRef.current.videoHeight;
        if (height) {
          const ceilHeight = Math.ceil(height);
          setVideoHeight(ceilHeight);
        }
      }
      // 重新获取图片高度
      if (gameImgsRef.current) {
        const height = gameImgsRef.current.offsetHeight;
        if (height) {
          setImageHeight(Math.ceil(height));
        }
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [game.video_url]);

  const menuRef = useRef(null);
  useEffect(() => {
    if (menuRef.current && !init) {
      setTimeout(() => {
        $(menuRef.current).css({
          scrollLeft: 0,
        });
      }, 200);
    }
  }, [init]);

  const swiperGameImgRef = useRef(null);

  useEffect(() => {
    if (
      game.video_url &&
      swiperGameImgRef.current &&
      swiperGameImgRef.current.swiper
    ) {
      setTimeout(() => {
        if (swiperGameImgRef.current?.swiper) {
          try {
            swiperGameImgRef.current.swiper.update();
            swiperGameImgRef.current.swiper.updateSlides();
            swiperGameImgRef.current.swiper.updateAutoHeight();
          } catch (e) {
            // swiper可能已被销毁，忽略错误
          }
        }
      }, 300);
    }
  }, [game.video_url]);

  // 初始化时根据当前索引设置高度
  useEffect(() => {
    if (swiperGameImgRef.current?.swiper) {
      const currentIndex = swiperGameImgRef.current.swiper.activeIndex;
      currentHeightIndexRef.current = currentIndex;
      setTimeout(() => {
        if (game.video_url && currentIndex === 0) {
          // 当前是视频
          if (videoRef.current) {
            const height =
              videoRef.current.offsetHeight || videoRef.current.videoHeight;
            if (height) {
              setVideoHeight(Math.ceil(height));
            }
          }
        } else {
          // 当前是图片
          if (gameImgsRef.current) {
            const height = gameImgsRef.current.offsetHeight;
            if (height) {
              setImageHeight(Math.ceil(height));
            }
          }
        }
      }, 200);
    }
  }, [game.video_url, game.game_ur_list, swiperGameImgRef.current?.swiper]);

  const [swiperIndex, setSwiperIndex] = useState(0);
  const swiperPreviousIndexRef = useRef(0);
  const gameVideoImgsRef = useRef(null);
  const touchStartXRef = useRef(0);
  const touchStartIndexRef = useRef(0);
  const currentHeightIndexRef = useRef(0); // 跟踪当前高度对应的索引

  // 同时更新容器和 swiper-wrapper 的高度
  const updateContainerHeight = useCallback(
    (height, useTransition = false, transitionDuration = "0.3s") => {
      if (gameVideoImgsRef.current) {
        const heightValue = height !== "auto" ? height + "px" : "auto";

        // 更新容器高度
        if (useTransition) {
          gameVideoImgsRef.current.style.transition = `height ${transitionDuration} ease`;
        } else {
          gameVideoImgsRef.current.style.transition = "none";
        }
        gameVideoImgsRef.current.style.height = heightValue;

        // 更新 swiper-wrapper 高度
        const swiperWrapper =
          gameVideoImgsRef.current.querySelector(".swiper-wrapper");
        if (swiperWrapper) {
          if (useTransition) {
            swiperWrapper.style.transition = `height ${transitionDuration} ease`;
          } else {
            swiperWrapper.style.transition = "none";
          }
          swiperWrapper.style.height = heightValue;
        }
      }
    },
    []
  );

  useEffect(() => {
    console.log("swiperIndex----", swiperIndex);
  }, [swiperIndex]);

  // 同步更新 swiper-wrapper 的高度
  useEffect(() => {
    if (gameVideoImgsRef.current) {
      const isVideo = game.video_url && swiperIndex === 0;
      const targetHeight = isVideo ? videoHeight : imageHeight;

      if (targetHeight) {
        const swiperWrapper =
          gameVideoImgsRef.current.querySelector(".swiper-wrapper");
        if (swiperWrapper) {
          swiperWrapper.style.height = targetHeight + "px";
        }
      }
    }
  }, [swiperIndex, videoHeight, imageHeight, game.video_url]);

  // 获取图片容器高度
  useEffect(() => {
    const getImageHeight = () => {
      if (gameImgsRef.current) {
        const height = gameImgsRef.current.offsetHeight;
        if (height) {
          setImageHeight(Math.ceil(height));
        }
      }
    };

    // 等待图片加载完成
    if (game.game_ur_list?.length > 0 && gameImgsRef.current) {
      // 使用 setTimeout 确保 DOM 已经渲染
      setTimeout(() => {
        const images = gameImgsRef.current?.querySelectorAll("img");
        if (images && images.length > 0) {
          let loadedCount = 0;
          const totalImages = images.length;

          const checkAllLoaded = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              // 所有图片加载完成后，延迟一点再获取高度，确保渲染完成
              setTimeout(() => {
                getImageHeight();
              }, 100);
            }
          };

          images.forEach((img) => {
            if (img.complete) {
              checkAllLoaded();
            } else {
              img.addEventListener("load", checkAllLoaded);
              img.addEventListener("error", checkAllLoaded);
            }
          });

          // 如果所有图片已经加载完成
          if (loadedCount === totalImages) {
            setTimeout(() => {
              getImageHeight();
            }, 100);
          }

          return () => {
            images.forEach((img) => {
              img.removeEventListener("load", checkAllLoaded);
              img.removeEventListener("error", checkAllLoaded);
            });
          };
        } else {
          // 如果没有图片，延迟获取高度
          setTimeout(() => {
            getImageHeight();
          }, 200);
        }
      }, 100);
    }
  }, [game.game_ur_list]);

  function formatWelfare(text) {
    let endStr = text
      // ★【xxx】：内容
      .replace(/^★【([^】]+)】：(.+)$/gm, (_, title, content) => {
        return `<div style="margin-top: 16px;"></div><img class="gift-img-star" src="/resources/four-three/game-detail/welfare-star.png"><span class="gift-tag">${title}</span><div style="margin-top: 3px;"></div>${content}`;
      })
      // ★xxx：内容，不包含【】
      .replace(/^★([^【：]+)：(.+)$/gm, (_, title, content) => {
        return `<div style="margin-top: 16px;"></div><img class="gift-img-star" src="/resources/four-three/game-detail/welfare-star.png"><span class="gift-tag">${title}</span><div style="margin-top: 3px;"></div>${content}`;
      });
    return endStr;
  }

  return (
    <div className="game-index">
      {game.video_url || game.game_ur_list?.length > 0 ? (
        <div
          ref={gameVideoImgsRef}
          className="game-video-imgs"
          style={{
            height:
              game.video_url && swiperIndex === 0
                ? videoHeight
                  ? videoHeight + "px"
                  : "4.04rem"
                : imageHeight
                  ? imageHeight + "px"
                  : "auto",
            transition: "height 0.3s ease",
          }}
        >
          <Swiper
            ref={swiperGameImgRef}
            loop={false}
            autoplay={false}
            pagination={{
              clickable: true,
              bulletClass: "swiper-game-img-pagination-bullet",
              bulletActiveClass: "swiper-game-img-pagination-bullet-active",
              renderBullet: function (index, className) {
                return `<span class="${className}">${game.video_url && index === 0 ? "宣传片" : "宣传图"
                  }</span>`;
              },
            }}
            onTouchStart={(swiper) => {
              // 记录滑动开始时的索引
              const startIndex = swiper.activeIndex;
              touchStartIndexRef.current = startIndex;
              swiperPreviousIndexRef.current = startIndex;
            }}
            onProgress={(swiper, progress) => {
              // 根据滑动进度实时插值计算高度
              // progress: 0 表示在起始位置，1 表示在目标位置
              if (gameVideoImgsRef.current && Math.abs(progress) > 0.01) {
                const currentIndex = touchStartIndexRef.current;
                const totalSlides = game.video_url ? 2 : 1;

                // 根据 progress 判断滑动方向
                let targetIndex = currentIndex;
                if (progress > 0 && currentIndex < totalSlides - 1) {
                  targetIndex = currentIndex + 1;
                } else if (progress < 0 && currentIndex > 0) {
                  targetIndex = currentIndex - 1;
                }

                // 获取起始和目标高度
                const isCurrentVideo = game.video_url && currentIndex === 0;
                const isTargetVideo = game.video_url && targetIndex === 0;

                const startHeight = isCurrentVideo ? videoHeight : imageHeight;
                const targetHeight = isTargetVideo ? videoHeight : imageHeight;

                if (
                  startHeight &&
                  targetHeight &&
                  startHeight !== targetHeight
                ) {
                  // 高度不同时，根据进度插值计算当前高度，实时更新
                  const progressValue = Math.abs(progress);
                  const currentHeight =
                    startHeight + (targetHeight - startHeight) * progressValue;

                  // 临时移除 transition，实时更新高度
                  updateContainerHeight(currentHeight, false);

                  // 更新索引状态
                  if (targetIndex !== currentHeightIndexRef.current) {
                    currentHeightIndexRef.current = targetIndex;
                    setSwiperIndex(targetIndex);
                  }
                }
                // 如果高度相同，不在 onProgress 中更新，让 onTransitionStart 或 onSetTransition 来处理
                // 这样可以保持 Swiper 的平滑过渡效果
              }
            }}
            onTransitionStart={(swiper) => {
              // 过渡开始时更新高度，使用 transition 让切换更平滑
              const targetIndex = swiper.activeIndex;
              const isVideo = game.video_url && targetIndex === 0;

              // 获取当前和目标高度
              const currentHeight = isVideo ? videoHeight : imageHeight;
              const previousIndex =
                swiper.previousIndex ?? swiperPreviousIndexRef.current;
              const isPreviousVideo = game.video_url && previousIndex === 0;
              const previousHeight = isPreviousVideo
                ? videoHeight
                : imageHeight;

              // 立即更新索引
              setSwiperIndex(targetIndex);
              currentHeightIndexRef.current = targetIndex;

              // 只有当高度不同时才更新高度，高度相同时不更新，保持 Swiper 的平滑过渡
              if (currentHeight && currentHeight !== previousHeight) {
                // 获取 Swiper 的过渡时间，默认 300ms
                const swiperTransition = swiper.params?.speed || 300;
                const transitionDuration = `${swiperTransition}ms`;
                updateContainerHeight(currentHeight, true, transitionDuration);
              }
            }}
            onSetTransition={(swiper, duration) => {
              // 在设置过渡动画时更新高度（比 onTransitionStart 更早）
              const currentIndex =
                swiper.previousIndex ?? swiperPreviousIndexRef.current;
              const targetIndex = swiper.activeIndex;

              // 只有在索引改变时才更新
              if (
                targetIndex !== currentIndex &&
                targetIndex !== currentHeightIndexRef.current
              ) {
                const isVideo = game.video_url && targetIndex === 0;
                const isPreviousVideo = game.video_url && currentIndex === 0;

                // 获取当前和目标高度
                const targetHeight = isVideo ? videoHeight : imageHeight;
                const previousHeight = isPreviousVideo
                  ? videoHeight
                  : imageHeight;

                // 立即更新索引
                setSwiperIndex(targetIndex);
                swiperPreviousIndexRef.current = targetIndex;
                currentHeightIndexRef.current = targetIndex;

                // 只有当高度不同时才更新高度，高度相同时不更新，保持 Swiper 的平滑过渡
                if (targetHeight && targetHeight !== previousHeight) {
                  const transitionDuration = duration
                    ? `${duration}ms`
                    : "300ms";
                  updateContainerHeight(targetHeight, true, transitionDuration);
                }
              }
            }}
            onSlideChangeTransitionStart={(swiper) => {
              // 滑动过渡开始时，确保高度已更新
              const targetIndex = swiper.activeIndex;
              setSwiperIndex(targetIndex);

              // 再次确保高度已更新（作为备用），使用 transition
              if (targetIndex !== currentHeightIndexRef.current) {
                const isVideo = game.video_url && targetIndex === 0;
                const previousIndex =
                  swiper.previousIndex ?? swiperPreviousIndexRef.current;
                const isPreviousVideo = game.video_url && previousIndex === 0;

                const targetHeight = isVideo ? videoHeight : imageHeight;
                const previousHeight = isPreviousVideo
                  ? videoHeight
                  : imageHeight;

                // 只有当高度不同时才更新高度，高度相同时不更新，保持 Swiper 的平滑过渡
                if (targetHeight && targetHeight !== previousHeight) {
                  const swiperTransition = swiper.params?.speed || 300;
                  const transitionDuration = `${swiperTransition}ms`;
                  updateContainerHeight(targetHeight, true, transitionDuration);
                }
                currentHeightIndexRef.current = targetIndex;
              }
            }}
            onSlideChange={(swiper) => {
              console.log("swiper.activeIndex----", swiper.activeIndex);

              setSwiperIndex(swiper.activeIndex);

              // 恢复 transition（同时更新容器和 swiper-wrapper）
              const targetIndex = swiper.activeIndex;
              const isVideo = game.video_url && targetIndex === 0;
              const targetHeight = isVideo ? videoHeight : imageHeight;

              if (targetHeight && gameVideoImgsRef.current) {
                // 恢复 transition
                gameVideoImgsRef.current.style.transition = "height 0.3s ease";
                const swiperWrapper =
                  gameVideoImgsRef.current.querySelector(".swiper-wrapper");
                if (swiperWrapper) {
                  swiperWrapper.style.transition = "height 0.3s ease";
                }
              }

              // 滑动后重新获取当前内容的高度
              setTimeout(() => {
                if (game.video_url && swiper.activeIndex === 0) {
                  // 滑动到视频
                  if (videoRef.current) {
                    const video = videoRef.current;
                    // 优先使用视频的实际宽高比来计算高度
                    if (video.videoWidth && video.videoHeight) {
                      const screenWidth = window.innerWidth;
                      const aspectRatio = video.videoHeight / video.videoWidth;
                      const calculatedHeight = screenWidth * aspectRatio;
                      const maxHeight = window.innerHeight * 0.55; // 55vh
                      const finalHeight = Math.min(calculatedHeight, maxHeight);

                      if (finalHeight > 0) {
                        setVideoHeight(Math.ceil(finalHeight));
                        // 更新swiper，确保pagination位置正确
                        if (swiperGameImgRef.current?.swiper) {
                          try {
                            swiperGameImgRef.current.swiper.update();
                          } catch (e) {
                            // swiper可能已被销毁，忽略错误
                          }
                        }
                      }
                    } else {
                      // 如果视频宽高比不可用，使用offsetHeight或videoHeight
                      const height = video.offsetHeight || video.videoHeight;
                      if (height) {
                        setVideoHeight(Math.ceil(height));
                      }
                    }
                  }
                } else {
                  // 滑动到图片
                  if (gameImgsRef.current) {
                    const height = gameImgsRef.current.offsetHeight;
                    if (height) {
                      setImageHeight(Math.ceil(height));
                    }
                  }
                }
              }, 100);
            }}
          >
            {game.video_url && (
              <SwiperSlide>
                <div className="video-main">
                  <div className="game-video">
                    <video
                      ref={videoRef}
                      autoPlay
                      muted
                      controls
                      poster={game?.video_img_url}
                      preload="metadata"
                      webkit-playsinline="true"
                      playsInline={true}
                      loop
                      src={game.video_url}
                      type="video/mp4"
                    ></video>
                  </div>
                </div>
              </SwiperSlide>
            )}

            <SwiperSlide>
              <div className="game-imgs" ref={imgRef}>
                <div className="container" ref={menuRef}>
                  {game.game_ur_list?.map((img, index, imgs) => (
                    <Link
                      key={index}
                      to={"/img?imgs=" + imgs + "&img=" + index}
                      className="bannerImg"
                    >
                      <Image src={img} alt="" />
                    </Link>
                  ))}
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      ) : null}

      <div className="game-info-content">
        <div className="game-list-global-type game-detail-icon-title">
          <div className="game-list-global-type-left">
            <div className="icon">
              <Image src={game?.game_image?.thumb} />
            </div>
            <div className="data">
              <div className="name">
                <div className="name-main" style={{ flex: "none" }}>
                  {game.game_name_main || game.game_name}
                </div>
              </div>

              {game.game_name_branch && (
                <div className="desc">{game.game_name_branch}</div>
              )}

              <div
                className="game-service"
                onClick={() => {
                  props.setServerShow(true);
                }}
              >
                {game.kaifu_info &&
                  game.kaifu_info.length > 0 &&
                  openService.info?.serviceName != "动态开服"
                  ? `${openService.info?.dayTime} ${openService.info?.serviceName}`
                  : "动态开服中"}

                <img
                  src="/resources/game/server-arrow.png"
                  alt=""
                  style={{ width: "18px" }}
                />
              </div>
            </div>
          </div>

          {game?.game_tags?.is_premium_game == 2 ? (
            <div
              className="is-premium"
              style={{
                backgroundImage: "url('/resources/common/boutique.png')",
              }}
            >
              {game.discount < 1 ? (
                <p className="is-premium-discount">
                  {parseFloat((game.discount * 10).toFixed(2))}折
                </p>
              ) : null}
              <p
                className="boutique"
                style={{ fontWeight: game.discount < 1 ? "normal" : "bold" }}
              >
                精品游戏
              </p>
            </div>
          ) : game?.game_tags?.is_free_version == 2 ? (
            <div className="is-free-version">
              <span>免费版</span>
            </div>
          ) : (
            <>
              {game.discount < 1 ? (
                <div
                  className="is-free-version"
                  style={{ fontSize: "0.32rem", letterSpacing: "1px" }}
                >
                  {parseFloat((game.discount * 10).toFixed(2))}
                  <span style={{ fontSize: "0.24rem" }}>折</span>
                </div>
              ) : null}
            </>
          )}
        </div>

        <div className="game-tab">
          <Link to={"/game/gift?id=" + game.game_id} className="tab-every">
            <div className="every-top">
              {(game.gift_bag_list?.length && game.gift_bag_list?.length) || 0}
              {/* {!game?.giftClick && <div className="gift-click-circle"></div>} */}
            </div>
            <div className="every-bottom">
              <img
                src="/resources/four-three/game-detail/gift.png"
                alt=""
                className="bottom-info-icon"
              />
              <span className="bottom-info">礼包</span>
            </div>
          </Link>

          <div className="line"></div>

          <Link to={"/game/voucher?id=" + game.game_id} className="tab-every">
            <div className="every-top">
              <span style={{ fontSize: "0.24rem" }}>￥</span>
              {game.voucher_info?.amount || 0}
              {/* {!game?.voucherClick && <div className="gift-click-circle"></div>} */}
            </div>
            <div className="every-bottom">
              <img
                src="/resources/four-three/game-detail/voucher.png"
                alt=""
                className="bottom-info-icon"
              />
              <span className="bottom-info">代金券</span>
            </div>
          </Link>

          <div className="line"></div>

          <Link
            to={`/game/articleGroup?game_id=${game.game_id}`}
            className="tab-every"
          >
            <div className="every-top">
              {game?.game_activity_total || 0}
              {/* {!game?.rebateClick && <div className="gift-click-circle"></div>} */}
            </div>
            <div className="every-bottom">
              <img
                src="/resources/four-three/game-detail/rebate.png"
                alt=""
                className="bottom-info-icon"
              />
              <span className="bottom-info">返利</span>
            </div>
          </Link>

          <div className="line"></div>

          <Link
            to={`/game/trade?game_id=${game.game_id}`}
            className="tab-every"
          >
            <div className="every-top">
              {game?.trad_num || 0}
              {/* {!game?.tradeClick && <div className="gift-click-circle"></div>} */}
            </div>
            <div className="every-bottom">
              <img
                src="/resources/four-three/game-detail/trade.png"
                alt=""
                className="bottom-info-icon"
              />
              <span className="bottom-info">精选交易</span>
            </div>
          </Link>
        </div>
      </div>

      {game.game_classify_name?.filter(
        (item) => item.tagname == "有奖试玩" && item.is_trial_game == 2
      )?.length > 0 ||
        game.is_game_sgin == 1 ||
        game.is_support_flb == 1 ? (
        <div className="game-detail-welfare">
          <p className="game-detail-title" style={{ marginBottom: "12px" }}>
            独家福利
          </p>

          {game.game_classify_name?.filter(
            (item) => item.tagname == "有奖试玩" && item.is_trial_game == 2
          )?.length > 0 && (
              <>
                <NavLink
                  user={false}
                  to={`${activityUrl}/play-win`}
                  iframe={{ title: "有奖试玩" }}
                  className="game-detail-welfare-every"
                >
                  <div className="game-detail-welfare-left">
                    <img
                      className="game-detail-welfare-left-img"
                      src="/resources/four-three/game-detail/play.png"
                      alt=""
                    />

                    <div>
                      <p className="game-detail-welfare-left-title">有奖试玩</p>
                      <p className="game-detail-welfare-left-desc">
                        完成任务领取福利币
                      </p>
                    </div>
                  </div>

                  <img
                    src="/resources/four-three/game-detail/welfare-arrow.png"
                    style={{ width: "20px" }}
                  />
                </NavLink>

                {(game.is_game_sgin == 1 || game.is_support_flb == 1) && (
                  <div className="game-detail-welfare-every-line"></div>
                )}
              </>
            )}

          {game.is_game_sgin == 1 && (
            <>
              <NavLink
                user={false}
                to={`${activityUrl}/daily-sign-in?gameId=${game.maiyou_gameid}`}
                iframe={{ title: "每日签到" }}
                className="game-detail-welfare-every"
              >
                <div className="game-detail-welfare-left">
                  <img
                    className="game-detail-welfare-left-img"
                    src="/resources/four-three/game-detail/sign.png"
                    alt=""
                  />

                  <div>
                    <p className="game-detail-welfare-left-title">每日签到</p>
                    <p className="game-detail-welfare-left-desc">
                      签到领好礼，福利拿不停
                    </p>
                  </div>
                </div>

                <img
                  src="/resources/four-three/game-detail/welfare-arrow.png"
                  style={{ width: "20px" }}
                />
              </NavLink>

              {game.is_support_flb == 1 && (
                <div className="game-detail-welfare-every-line"></div>
              )}
            </>
          )}

          {game.is_support_flb == 1 && (
            <NavLink
              user={false}
              to={`${sysUrl}/home/monthCard`}
              iframe={{ title: "省钱卡" }}
              className="game-detail-welfare-every"
            >
              <div className="game-detail-welfare-left">
                <img
                  className="game-detail-welfare-left-img"
                  src="/resources/four-three/game-detail/card.png"
                  alt=""
                />

                <div>
                  <p className="game-detail-welfare-left-title">省钱卡</p>
                  <p className="game-detail-welfare-left-desc">
                    开通即回本，每日再领5元
                  </p>
                </div>
              </div>

              <img
                src="/resources/four-three/game-detail/welfare-arrow.png"
                style={{ width: "20px" }}
              />
            </NavLink>
          )}
        </div>
      ) : null}

      <div className="game-detail-welfare" style={{ paddingBottom: "18px" }}>
        <p className="game-detail-title" style={{ marginBottom: "2px" }}>
          游戏福利
        </p>

        <div className="game-tag">
          {game.game_control_info?.double_ended === 1 && (
            <div
              className="tag-every"
              onClick={() => {
                document.body.style.overflow = "hidden";

                Dialog.tips(
                  "双端互通说明",
                  <div className="box-tips-content">
                    双端互通就是游戏的数据在安卓端和苹果端都能进行角色互通共享的游戏
                  </div>,
                  () => {
                    document.body.style.overflow = "auto";
                  }
                );
              }}
            >
              双端互通
              <img
                src="/resources/game/label-more.png"
                style={{ width: "8px" }}
              />
            </div>
          )}

          <div
            className="tag-every"
            onClick={() => {
              document.body.style.overflow = "hidden";

              Dialog.intro(
                "游戏简介",
                <div
                  style={{
                    padding: "0 1px",
                    fontSize: "0.28rem",
                    lineHeight: "0.48rem",
                    fontWeight: "normal",
                    color: "#3d3d3d",
                    textAlign: "left",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: (
                      game?.game_introduce_main || game?.game_introduce
                    )?.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br>$2"),
                  }}
                ></div>,
                () => {
                  document.body.style.overflow = "auto";
                }
              );
            }}
          >
            游戏简介
            <img
              src="/resources/game/label-more.png"
              style={{ width: "8px" }}
            />
          </div>

          {game.game_classify_name?.map((item) => (
            <Fragment key={item.id}>
              {item.tagname == "专服" && item.is_special_server_game == 2 ? (
                <div className="tag-every">
                  <NavLink
                    user={false}
                    to={`${sysUrl}/home/actcloudhook/game?id=0&type=3&device=10`}
                    iframe={{ title: item.tagname }}
                  >
                    {item.tagname}
                    <img
                      src="/resources/game/label-more.png"
                      style={{ width: "8px" }}
                    />
                  </NavLink>
                </div>
              ) : (
                <>
                  {item.tagname != "专服" && item.tagname != "有奖试玩" && (
                    <div className="tag-every">
                      <NavLink
                        user={false}
                        to={`${sysUrl}/home/actcloudhook/game?id=${item.id}&type=${item.type}&device=10`}
                        iframe={{ title: item.tagname }}
                      >
                        {item.tagname}
                        <img
                          src="/resources/game/label-more.png"
                          style={{ width: "8px" }}
                        />
                      </NavLink>
                    </div>
                  )}
                </>
              )}
            </Fragment>
          ))}

          {game.cloud_hanging_up?.list?.map((item) => (
            <div key={item.id} className="tag-every">
              <NavLink
                user={false}
                to={`${sysUrl}/home/actcloudhook/game?id=${item.id}&type=${item.type}&device=10`}
                iframe={{ title: item.title }}
              >
                {item.title}
                <img
                  src="/resources/game/label-more.png"
                  style={{ width: "8px" }}
                />
              </NavLink>
            </div>
          ))}
        </div>

        {game?.game_feature_list?.[0]?.content && (
          <div
            className={
              "game-detail-welfare-game" + (manufacturerMored ? " more" : "")
            }
            ref={manufacturerBodyRef}
          >
            <div
              className="manufacturer-entity"
              ref={manufacturerEntityRef}
              dangerouslySetInnerHTML={{
                __html: formatWelfare(game.game_feature_list[0].content),
              }}
            ></div>
          </div>
        )}

        {manufacturerInfoMore && (
          <div
            className={"more " + (manufacturerMored ? "ed" : "")}
            onClick={() => setManufacturerMored(!manufacturerMored)}
          >
            {manufacturerMored ? (
              <div className="more-text">
                收起
                <img src="/resources/four-three/game-detail/up.png" alt="" />
              </div>
            ) : (
              <div className="more-text">
                展开
                <img src="/resources/four-three/game-detail/down.png" alt="" />
              </div>
            )}
          </div>
        )}
      </div>

      <div className="game-games">
        <div className="head">
          <p className="game-detail-title">猜你喜欢</p>

          <div className="operate" onClick={() => recommend()}>
            <img
              className="icon"
              src="/resources/four-three/game-detail/refresh.png"
            />
            换一批
          </div>
        </div>
        <div className="body">
          {game.recommend_info?.map((game) => (
            <Link
              key={game.game_id}
              to={"/game?id=" + game.game_id}
              className="item"
            >
              <div className="icon">
                <Image src={game.game_image.thumb} alt="" />
              </div>
              <div className="name">
                {game.game_name_main || game.game_name}
              </div>

              <div className="info">{splitStr(game.version, 1)}</div>
            </Link>
          ))}
        </div>
      </div>

      <div className="game-manufacturer-wrapper">
        <div className="manufacturer-mask"></div>
        <div className="game-manufacturer">
          {game.game_control_info?.authority_info && (
            <NavLink
              className="manufacturer-link"
              user={false}
              to={`${sysUrl}/home/CompanyJurisdiction?gameId=${game.game_id}&maiyouGameId=${game.maiyou_gameid}&device=web`}
              iframe={{ title: "权限信息" }}
            >
              权限信息
              <img
                src="/resources/four-three/game-detail/manu-arrow.png"
                alt=""
              />
            </NavLink>
          )}

          {game.game_control_info?.privacy_policy && (
            <NavLink
              className="manufacturer-link"
              user={false}
              to={`${sysUrl}/home/CompanyJurisdiction/web?gameId=${game.game_id}&maiyouGameId=${game.maiyou_gameid}&device=web`}
              iframe={{ title: "隐私政策" }}
            >
              隐私政策
              <img
                src="/resources/four-three/game-detail/manu-arrow.png"
                alt=""
              />
            </NavLink>
          )}

          {game.game_control_info?.filings_number && (
            <div className="manufacturer-link">
              软件备案 {game.game_control_info?.filings_number}
            </div>
          )}

          <div className="manufacturer-link">
            软件版本 {game.game_control_info?.version?.ios}
          </div>

          <div className="manufacturer-link">
            厂商信息 {game.game_control_info?.company_name}
          </div>
        </div>
      </div>
    </div>
  );
};
